import { Link } from "react-router-dom";
import { ArrowRight, Newspaper } from "lucide-react";
import { motion } from "framer-motion";
import { Badge } from "@/components/ui/badge";
import { easeOutStrong } from "@/lib/motion";

const MotionLink = motion(Link);

export default function BlogCard({ post }) {
    const date = post.published_date
        ? new Date(post.published_date).toLocaleDateString("en-GB", {
              day: "numeric",
              month: "short",
              year: "numeric",
          })
        : "";
    return (
        <MotionLink
            to={`/blog/${post.slug}`}
            data-testid={`blog-card-${post.slug}`}
            className="group bg-white border border-slate-200 rounded-2xl overflow-hidden flex flex-col"
            whileHover={{
                y: -8,
                scale: 1.02,
                boxShadow: "0 20px 40px -12px rgba(124, 107, 255, 0.35)",
            }}
            whileTap={{ scale: 0.99 }}
            transition={{ duration: 0.25, ease: easeOutStrong }}
            style={{ willChange: "transform" }}
        >
            <div className="aspect-[16/9] bg-slate-100 relative overflow-hidden">
                {post.featured_image ? (
                    <img
                        src={post.featured_image}
                        alt={post.title}
                        className="absolute inset-0 w-full h-full object-cover group-hover:scale-[1.06] transition-transform duration-700"
                    />
                ) : (
                    <div className="absolute inset-0 grid place-items-center text-slate-400">
                        <Newspaper className="w-10 h-10" />
                    </div>
                )}
            </div>
            <div className="p-6 flex flex-col flex-1">
                <div className="flex items-center gap-2 text-xs text-slate-500">
                    <Badge variant="outline" className="text-slate-700 border-slate-200">
                        {post.category}
                    </Badge>
                    {date && <span>· {date}</span>}
                </div>
                <h3 className="font-display text-lg font-bold text-slate-950 mt-3 leading-snug">
                    {post.title}
                </h3>
                <p className="text-sm text-slate-600 mt-2 leading-relaxed line-clamp-3 flex-1">
                    {post.short_summary}
                </p>
                <div className="mt-4 inline-flex items-center gap-1.5 text-sm font-semibold text-slate-950">
                    Read article
                    <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
                </div>
            </div>
        </MotionLink>
    );
}
